


























































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import dayjs from "dayjs";
import { Toast } from "vant";
import { TbOrderPad, TbReport, TbShopAccount } from "@/http";
import calculate from "@/common/util/calculate";
import { fmoney } from "@/common/util/money";
@Component({
  components: {},
})
export default class goodsjydetail extends Vue {
  public $refs: {};

  show = false;

  form: any = {};
  list = [];
  type = 1;
  curfl = null;

  fmoney = fmoney;

  loading = false;
  changesyy = false;
  cashierlist = [];
  curselid = "";
  curselname = "";
  start = dayjs(new Date()).format("YYYY-MM-DD");
  end = dayjs(new Date()).format("YYYY-MM-DD");

  created() {}
  mounted() {}

  async init(id) {
    this.loading = true;
    try {
      let res = await TbReport.GetGoodsSalesDetails({
        goodsItemId: id,
        tradingBehavior: this.curfl,
        start: this.start,
        end: this.end,
        shopId: JSON.parse(localStorage.getItem("padUserinfo")).shopId,
      });
      this.list = res.items;
      this.loading = false;
    } catch (error) {
      this.loading = false;
    }
  }
  getnumall() {
    return this.list
      .map((v) => {
        if (v.tradingBehavior == 1) {
          return v.num;
        } else {
          return -v.num;
        }
      })
      .reduce((pre, cur) => {
        return Number(pre) + Number(cur);
      }, 0);
  }
  getpriceall() {
    let prall = this.list
      .map((v) => {
        if (v.tradingBehavior == 1) {
          return v.price;
        } else {
          return -v.price;
        }
      })
      .reduce((pre, cur) => {
        return (Number(pre) + Number(cur)).toFixed(2);
      }, 0);
    if (Number(prall) < 0) {
      return "-￥" + Math.abs(prall);
    } else {
      return "￥" + prall;
    }
  }

  async showFun(item, start, end) {
    this.form = item;
    console.log(this.form);
    this.start = start;
    this.end = end;
    this.curfl = null;
    let id = item.name == "无码商品" ? item.name : item.goodsItemId;
    await this.init(id);
    this.show = true;
  }

  closeFun() {
    this.resetFun();
    this.show = false;
  }
  resetFun() {
    this.form = {};
  }
  selfl(tag) {
    this.curfl = tag;
    let id = this.form.name == "无码商品" ? this.form.name : this.form.goodsItemId;
    this.init(id);
  }
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/padViews/report/components/goodsjydetail.vue